import apiClient from '../lib/apiClient';

const locationsService = {
  // Get all locations
  getLocations: async (filters = {}) => {
    try {
      const result = await apiClient.get('/locations', filters);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch locations' };
    }
  },

  // Get location by ID
  getLocation: async (id) => {
    try {
      const result = await apiClient.get(`/locations/${id}`);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch location' };
    }
  },

  // Create location
  createLocation: async (data) => {
    try {
      const result = await apiClient.post('/locations', data);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to create location' };
    }
  },

  // Update location
  updateLocation: async (id, data) => {
    try {
      const result = await apiClient.put(`/locations/${id}`, data);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to update location' };
    }
  },

  // Delete location
  deleteLocation: async (id) => {
    try {
      const result = await apiClient.delete(`/locations/${id}`);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to delete location' };
    }
  }
};

export default locationsService;

